import icon from "../assets/images/icon.png";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface FormUploadProps {
  isFolder: boolean;
  setIsFolder: Dispatch<SetStateAction<boolean>>;
  fileInputRef: React.MutableRefObject<HTMLInputElement | null>; 
  uploadFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showProgress: boolean;
  handleFileInputClick: () => void;
}
const FormUploadComponent: React.FC<FormUploadProps> = ({
  isFolder,
  setIsFolder,
  fileInputRef,
  uploadFile,
  showProgress,
  handleFileInputClick,
}) => {
  const { t } = useTranslation();
  
  return (
    <form className='lg:px-[10%] font-gellix md:px-2 flex flex-col gap-4' method='post'>
      <div className="flex flex-wrap gap-2 items-center bg-green-60">{t("key_upload")}
      
        <div className="flex items-center gap-3">
          <span className={isFolder ? "" : "bg-green-500 text-white font-bold px-2 pb-1 rounded-lg"}>{t("key_files")}</span>

          <label className="relative inline-block w-11 h-6 cursor-pointer">
            <input type="checkbox" checked={isFolder}
              onChange={(e) => setIsFolder(e.target.checked)}
              className="peer sr-only" />
            <span className="absolute inset-0 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-green-500 dark:bg-neutral-700 dark:peer-checked:bg-green-500 peer-disabled:opacity-50 peer-disabled:pointer-events-none"></span>
            <span className="absolute top-1/2 start-0.5 -translate-y-1/2 size-5 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-full dark:bg-neutral-400 dark:peer-checked:bg-white"></span>
          </label>

          <span className={isFolder ? "bg-green-500 text-white font-bold px-2 rounded-lg pb-1" : ""}>{t("key_folders")}</span>
        </div>
      </div>

      <input className="file-input"
        type="file" name="files"
        hidden ref={fileInputRef}
        onChange={uploadFile}
        disabled={showProgress}
        multiple={isFolder}
        // @ts-ignore (car TypeScript ne connaît pas ces props)
        webkitdirectory={isFolder ? "true" : undefined}
        // @ts-ignore
        directory={isFolder ? "true" : undefined} />

      <div onClick={handleFileInputClick}
        className={`bg-white text-gray-400 rounded-lg flex flex-col gap-4 cursor-pointer justify-center items-center h-[15rem]  mb-4 ${showProgress ? "opacity-95 cursor-not-allowed" : ""}`}>
        <img src={icon} alt="Icon Upload Systalink" />
        <p className="text-center px-4">{showProgress ? "Uploading..." : t("key_placeholder_upload")}</p>
      </div>

      <p>{t("key_limits")}</p>
    </form>
  );
};
export default FormUploadComponent;
